import { type Enum } from '@webapp/infrastructure/types/Enum'

// Export-task type codes. Export History filters tasks by a
// comma-joined code list derived from the referrer report:
// orders and expenses referrers both filter on "9,10" (BHV-035).
// Code 11 (open-PO exports) is deprecated and intentionally omitted.
export const ExportTaskTypes = {
  ORDER_ITEMS: 9, // Orders report exports ("Order Items")
  EXPENSE_ITEMS: 10, // Expense report exports
} as const

export type ExportTaskType = Enum<typeof ExportTaskTypes>
